import angular from 'angular';

import Viewer from './viewer/viewer.component';
import './styles.scss';

export default angular.module('fileViewer', [Viewer]).name;
